<template>
  <div class="login-page">
    <div class="login-card card">
      <img v-if="logoExists" src="../assets/logo_igreja.png" alt="El Shaday" class="login-logo" />
      <h1 class="login-title">Check-in</h1>
      <p class="login-subtitle">Entre com sua conta de administrador</p>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label class="label" for="email">Email</label>
          <input class="input" type="email" id="email" v-model="form.email" placeholder="seu@email.com" required />
          <span class="error-msg" v-if="errors.email">{{ errors.email }}</span>
        </div>
        <div class="form-group">
          <label class="label" for="password">Senha</label>
          <input class="input" type="password" id="password" v-model="form.password" placeholder="Sua senha" required />
          <span class="error-msg" v-if="errors.password">{{ errors.password }}</span>
        </div>
        <button type="submit" class="btn-primary login-btn" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "../stores/auth";

export default {
  name: "LoginPage",
  data() {
    return {
      form: { email: "", password: "" },
      errors: {},
      loading: false,
      logoExists: true,
    };
  },
  methods: {
    validate() {
      this.errors = {};
      if (!this.form.email) {
        this.errors.email = "Email e obrigatorio";
      } else if (!/\S+@\S+\.\S+/.test(this.form.email)) {
        this.errors.email = "Email invalido";
      }
      if (!this.form.password) {
        this.errors.password = "Senha e obrigatoria";
      } else if (this.form.password.length < 6) {
        this.errors.password = "Minimo 6 caracteres";
      }
      return Object.keys(this.errors).length === 0;
    },
    async handleLogin() {
      if (!this.validate()) return;
      this.loading = true;
      try {
        const authStore = useAuthStore();
        const data = await authStore.login(this.form.email, this.form.password);
        this.$toast.open({ message: `Bem-vindo, ${data.admin.name}!`, type: "success", position: "top-right", duration: 3000 });
        this.$router.push("/");
      } catch (error) {
        const message = error.response?.data?.message || "Erro ao fazer login";
        this.$toast.open({ message, type: "error", position: "top-right", duration: 5000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-base);
}
.login-card {
  width: 100%;
  max-width: 420px;
  text-align: center;
}
.login-logo {
  width: 80px;
  height: 80px;
  border-radius: var(--radius-circle);
  margin-bottom: var(--spacing-base);
  object-fit: cover;
}
.login-title {
  font-size: var(--text-xl);
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-sm);
}
.login-subtitle {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin-bottom: var(--spacing-lg);
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  text-align: left;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.login-btn {
  width: 100%;
  margin-top: var(--spacing-md);
}
</style>
